import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_BREAKPOINTS, CONTAINER_MAX } from '@/constants/breakpoints';
import { flexBetween, flexCenterAligned } from '@/styles/common';

export const Wrapper = styled.header`
  position: fixed;
  top: var(--banner-header-offset, 0px);
  left: 0;
  width: 100%;
  ${flexBetween};
  padding: 0 16px;
  min-height: 58px;
  background: var(--bg-main);
  z-index: 4;

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) {
    display: none;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    height: 58px;
  }

  @media (max-width: ${CONTAINER_MAX.mobileM}) {
    padding: 0 12px;
  }
`;

export const LeftSection = styled.div`
  ${flexCenterAligned};
  gap: 16px;
  font-size: 0;
`;

export const RightSection = styled.div`
  ${flexCenterAligned};
  gap: 12px;
`;

export const BackButton = styled.button`
  ${flexCenterAligned};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-inline: -5px;
  color: var(--textAndLabels-main);

  svg {
    width: 19px;
    height: 15px;
  }
`;

export const Title = styled(Typography).attrs({ variant: 'h2' })`
  color: var(--textAndLabels-main);
`;
